/* ====================================================================
   ENHANCEMENTS, PART 2

   Progressive like pp-enhance.js -- if this never runs, nothing is lost.

     1. size chip on product cards
     2. --pp-header-bottom, so anything sticky can sit under the header
     3. scroll state on <html> (deeper header shadow once you move)
     4. hero wash parallax
     5. floating Filters pill on collection pages
     6. Escape closes the mega menu
   ==================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. size chip -------------------------------------------------
     Fujifilm renders one sample photo per product FORMAT, so a collection
     of blankets is the same photograph eight times at eight sizes -- the
     grid is genuinely hard to scan. Nearly every title leads with its
     dimensions ("80x60 Woven Photo Throw Blanket", "60 x 50 Sherpa Fleece
     Blanket", "11 oz White Ceramic Mug"), so lifting that onto the image
     as a chip makes the row readable at a glance.

     Deliberately conservative: if the title does not START with a clear
     size, no chip is drawn. A half-parsed chip would be worse than none.
     aria-hidden because the title already announces the same thing. */
  var SIZE_RE = /^\s*(\d{1,3}(?:\.\d)?\s*(?:x|×)\s*\d{1,3}(?:\.\d)?|\d{1,3}\s*oz\b|\d{1,2}(?:\.\d)?\s*(?:"|”|-)?\s*inch\b)/i;

  function sizeOf(title) {
    var m = title.match(SIZE_RE);
    if (!m) return null;
    return m[1]
      .replace(/\s*(?:x|×)\s*/i, '×')
      .replace(/\s+/g, ' ')
      .replace(/\binch\b/i, '"')
      .trim();
  }

  function chip(card) {
    if (card.getAttribute('data-pp-size')) return;
    var wrap = card.querySelector('.product-card__images-wrapper');
    var titleEl = card.querySelector('.product-card__title');
    if (!wrap || !titleEl) return;
    card.setAttribute('data-pp-size', '1');

    var size = sizeOf(titleEl.textContent || '');
    if (!size) return;

    var el = document.createElement('span');
    el.className = 'pp-size-chip';
    el.setAttribute('aria-hidden', 'true');
    el.textContent = size;
    wrap.appendChild(el);
  }

  function scanCards() {
    var cards = document.querySelectorAll('product-card, .product-card');
    for (var i = 0; i < cards.length; i++) chip(cards[i]);
  }

  /* ⛔ DELETED: headerMetric(), which published --pp-header-bottom.
     Nothing consumed it (checked every .css/.js/.liquid asset in the theme),
     it measured `header-component` once at load so it read 111px against a
     real 196px, and Aurora already publishes the same edge, correctly and
     live, as --gsc-header-bottom-side. A wrong number nobody reads is worse
     than no number. */

  /* ---- 3. scroll state + 4. hero wash parallax -----------------------
     The wash lags scroll by a sixth, which reads as depth. It can never
     expose a gap: the wash starts at the hero's top edge, which is `y`
     above the viewport once scrolled, and the wash only moves `0.16y`. */
  function scrollFx() {
    var wash = document.querySelector('.pp-hero__wash');
    var hero = document.querySelector('.pp-hero');
    var ticking = false;

    function frame() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.documentElement.classList.toggle('pp-scrolled', y > 8);
      if (!reduce && wash && hero && y < (hero.offsetHeight || 1) * 1.2) {
        wash.style.translate = '0 ' + Math.round(y * 0.16) + 'px';
      }
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(frame);
    }, { passive: true });

    frame();
  }

  /* ---- 5. floating Filters pill --------------------------------------
     ⚠ Making `.shop__header` itself `position: sticky` does NOT work: its
     parent `.shop__container` is `overflow: hidden`, which becomes the
     sticky containing block, so it scrolls away regardless. Rather than
     change overflow on a container that also clips the filter drawer and
     the carousels, float a pill that clicks the REAL filter button. */
  function filterPill() {
    var bar = document.querySelector('.shop__header');
    if (!bar || !('IntersectionObserver' in window)) return;

    function realBtn() {
      var btns = document.querySelectorAll('button[data-sidebar-id^="SidebarFilters"]');
      for (var i = 0; i < btns.length; i++) if (btns[i].offsetWidth > 0) return btns[i];
      return btns[0] || null;
    }
    if (!realBtn()) return;

    var pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'pp-filter-pill';
    pill.innerHTML = '<span aria-hidden="true">≡</span> Filters';
    pill.setAttribute('aria-label', 'Open filters');
    document.body.appendChild(pill);

    pill.addEventListener('click', function () {
      var b = realBtn();
      if (b) b.click();
    });

    new IntersectionObserver(function (entries) {
      pill.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '-140px 0px 0px 0px' }).observe(bar);
  }

  /* ---- 6. Escape closes the mega menu --------------------------------
     Aurora opens the panel on hover but gives it no keyboard dismissal --
     Escape did nothing, so a keyboard user who opened it had no way out
     but to tab through every link in it. `header-float-element` exposes
     `setVisible`, and the toggles expose `setExpand`; driving the
     component's own API keeps its internal state consistent instead of
     forcing attributes from outside. No-ops when nothing is open, so the
     search sidebar's own Escape handling is untouched. */
  function escapeClosesMega() {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var fe = document.querySelector('header-float-element.header__dropdown[aria-hidden="false"]');
      if (!fe) return;
      try {
        if (typeof fe.setVisible === 'function') fe.setVisible(false);
        else if (typeof fe.hide === 'function') fe.hide();
      } catch (err) {}
      var btns = document.querySelectorAll('header-float-element-btn');
      for (var i = 0; i < btns.length; i++) {
        try { if (typeof btns[i].setExpand === 'function') btns[i].setExpand(false); } catch (err) {}
      }
    });
  }

  function init() {
    try { scrollFx(); } catch (e) {}
    try { filterPill(); } catch (e) {}
    try { escapeClosesMega(); } catch (e) {}
    try {
      scanCards();
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; scanCards(); });
      }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
